import React, { useContext } from "react";
import firebase from "firebase/auth";

type Context = { user: firebase.User | null, token: string }

export const useAuth = () => {
    return useContext(AuthContext)
}

export const AuthContext = React.createContext<Context>({user: null, token: ''});